<template>
  <div id="cert_offline_check_view">
    <div class="notice-label">您的身份认证信息已通过！</div>
    <div class="notice-label">请留意短信及站内通知，及时参加协会年审考核。</div>

    <div class="table-outer" v-if="judge != null">
      <table class="table">
        <thead>
        <tr>
          <td>项目名称</td>
          <td>考核状态</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>理论考试</td>
          <td :class="[(judge.theoryTest == '未进行' || judge.theoryTest == null) ? 'prepare' : (judge.theoryTest == '已通过' ? 'done' : 'failed')]">{{judge.theoryTest == null ? '未进行' : judge.theoryTest}}</td>
        </tr>
        <tr>
          <td>体能考试</td>
          <td :class="[(judge.staminaTest == '未进行' || judge.staminaTest == null) ? 'prepare' : (judge.staminaTest == '已通过' ? 'done' : 'failed')]">{{judge.staminaTest == null ? '未进行' : judge.staminaTest}}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: "CertApplicationOfflineCheckVue",
  props: {
    judge: {
      default: ()=> null
    }
  },
  data() {
    return {
      theoryTest: '已通过', // 理论考试
      // staminaTest: '未进行' // 体能考试
      staminaTest: '未通过' // 体能考试
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
  #cert_offline_check_view {
    display: flex;
    min-height: 300px;
    flex-direction: column;
    align-items: center;
  }

  #cert_offline_check_view .notice-label {
    font-size: 1rem;
    color: #333;

  }
  #cert_offline_check_view .notice-label:not(:last-child) {
    margin-bottom: 5px;
  }


  #cert_offline_check_view .table-outer {
    max-width: 300px;
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }

  #cert_offline_check_view .table-outer .table thead td {
    font-weight: bold;
  }
  #cert_offline_check_view .table-outer .table td {
    border: none;
  }

  #cert_offline_check_view td.prepare {
    color: #aaa;
  }

  #cert_offline_check_view td.done {
    color: green;
  }

  #cert_offline_check_view td.failed {
    color: red;
  }


</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationOfflineCheckVue.vue